
    import * as React from 'react';

    const ChevronRight16 = ({ color = 'currentcolor', height = '16px', width = '16px', ...rest }) => {
      const svgStyle: React.CSSProperties = {...{"position":"absolute","top":"0","right":"0","bottom":"0","left":"0","width":"100%","height":"100%"}, fill: color};

      return (
        <div style={{ ...{"position":"relative"}, height, width }} { ...rest }>
          <svg viewBox="0 0 16 16" xmlnsXlink="http://www.w3.org/1999/xlink" style={svgStyle}><desc>{"Created with Sketch."}</desc><g id="ChevronRight_16_svg__Icons/Chevron/Right/16" stroke="none" strokeWidth={1} fillRule="evenodd"><polygon id="ChevronRight_16_svg__Path-15" fillRule="nonzero" transform="translate(8.030330, 8.053553) scale(-1, 1) translate(-8.030330, -8.053553) " points="11.5606602 2.40710678 10.8535534 1.7 4.5 8.05355339 10.8535534 14.4071068 11.5606602 13.7 5.91421356 8.05355339" /></g></svg>
        </div>
      );
    };

    ChevronRight16.displayName = 'ChevronRight16';

    export default ChevronRight16;
  